import apiUrl from '../../../../constants'
import axios from 'axios'
import CryptoJS from 'crypto-js';
import VueElementLoading from 'vue-element-loading';
import Multiselect from 'vue-multiselect'
import 'vue-multiselect/dist/vue-multiselect.min.css'
import { BasicSelect, ModelSelect } from 'vue-search-select';
import user_tracker from '../../../../usertracker'

export default {
  name: 'migrate-destinations',
  components: {
    BasicSelect,
    ModelSelect,
    VueElementLoading,
    Multiselect
  },
  data: function () {
    return {
      listHubZoneData: [],
      listHubData: [],
      cityList: [],
      targetcityid: '',
      targetcityname: '',
      sourcecityid: '',
      sourcecityname: '',
      sourceGroupNo: '',
      sourceGroupName: '',
      targetGroupNo: '',
      targetGroupName: '',
      parentHub: '',
      isLoading: false,
      isSourceLoading: false,
      isTargetLoading: false,
      useremail: '',
      sourceGroupNoList: [],
      targetGroupNoList: [],
      targetcityObjData: {
        value: "",
        text: ""
      },
      sourcecityObjData: {
        value: "",
        text: ""
      },
      sourceGroupNoObjData: {
        value: "",
        text: ""
      },
      targetGroupNoObjData: {
        value: "",
        text: ""
      },
      totalmappedhubs: 0,
      totalSelected: 0,
      destinationList: [],
      oldDestinationList: [],
      zoneLoading: '',
      hubLoading: '',
      checkAllHub: false,
      destinationLoading: false,
      addmodalShow: false,
      hubid: 0,
      hubzoneid: 0,
      oldDataSaved: false,
      showList: false,
      checkedHub: [],
      HubArr: [],
      destData: [],
      modelArr: [],
      allHubData: [],
      sourceGroupListError: '',
      targetGroupListError: '',
      userData:[]
    }
  },
  created: function () { },
  computed: {},
  mounted() {
    let userdetailEncrypt = window.localStorage.getItem('userdetail')
    let bytes = CryptoJS.AES.decrypt(userdetailEncrypt.toString(), 'Key');
    let plaintext = bytes.toString(CryptoJS.enc.Utf8);
    let userdetail = JSON.parse(plaintext)
    this.userData = userdetail;
    this.useremail = userdetail[0].email;
    this.getCityList();
  },
  methods: {
    selectedTarget(cityData) {
      this.targetcityObjData = cityData
      this.targetcityid = cityData.value
      this.targetcityname = cityData.text
      if (this.targetcityid != "") {
        this.getTargetCitywiseGroups();
      }
    },
    selectedSource(cityData) {
      this.hubzoneid = 0;
      this.sourcecityObjData = cityData
      this.sourcecityid = cityData.value
      this.sourcecityname = cityData.text
      if (this.sourcecityid != "") {
        this.destinationList = [];
        this.checkAllHub = false;
        this.showList = false;
        this.getSourceCitywiseGroups();
      }
    },
    selectedSourceGroupNo(groupNoData) {
      this.sourceGroupNoObjData = groupNoData;
      this.sourceGroupNo = groupNoData.value;
      this.sourceGroupName = groupNoData.text;
      this.checkedHub = [];
      this.getDestinations();
      this.getHubZoneData();
    },
    selectedTargetGroupNo(groupNoData) {
      this.targetGroupNoObjData = groupNoData;
      this.targetGroupNo = groupNoData.value;
      this.targetGroupName = groupNoData.text;
    },
    getCityList() {
      this.isLoading = true;
      axios({
        method: 'POST',
        'url': apiUrl.api_url_hubops + 'allcity/get',
        'data': {},
        headers: {
          'authorization': 'authkey xB84JJ89Hd25',
        }
      })
        .then(result => {
          this.isLoading = false;
          let cityList = result.data.ResponseData
          for (const element of cityList) {
            this.cityList.push({
              value: element.cityid,
              text: element.cityname
            })
          }
        }, error => {
          this.isLoading = false;
          console.error(error)
        })
    },
    getSourceCitywiseGroups() {
      if (this.sourcecityid == undefined || this.sourcecityid == '' || this.sourcecityid == null) {
        return false;
      }
      this.sourceGroupNoObjData = {};
      this.sourceGroupNoList = [];
      this.isSourceLoading = true;
      this.sourceGroupListError = '';
      axios({
        method: 'GET',
        // legacy backup: getGroupNamesFromCity
        // 'url': apiUrl.api_url_hubops + 'getGroupNamesFromCity?cityId=' + this.sourcecityid,
        'url': apiUrl.api_url_hubops + 'groups?cityId=' + this.sourcecityid + '&isActive=true&responseShape=namesOnly',
        'data': {},
        headers: {
          'authorization': 'authkey xB84JJ89Hd25',
        }
      })
        .then(result => {
          this.isSourceLoading = false;
          if (result.data.ResultCode == 100) {
            let groupTypeList = result.data.ResponseData
            for (const element of groupTypeList) {
              this.sourceGroupNoList.push({
                value: element.groupno,
                text: element.groupno + ' - ' + element.groupname
              })
            }
          } else {
            this.sourceGroupNoList = [];
            this.sourceGroupListError = 'List is empty!!';
          }
        }, error => {
          this.isSourceLoading = false;
          console.error(error)
        })
    },
    getTargetCitywiseGroups() {
      if (this.targetcityid == undefined || this.targetcityid == '' || this.targetcityid == null) {
        return false;
      }
      this.targetGroupNoObjData = {};
      this.targetGroupNoList = [];
      this.isTargetLoading = true;
      this.targetGroupListError = '';
      axios({
        method: 'GET',
        // legacy backup: getGroupNamesFromCity
        // 'url': apiUrl.api_url_hubops + 'getGroupNamesFromCity?cityId=' + this.targetcityid,
        'url': apiUrl.api_url_hubops + 'groups?cityId=' + this.targetcityid + '&isActive=true&responseShape=namesOnly',
        'data': {},
        headers: {
          'authorization': 'authkey xB84JJ89Hd25',
        }
      })
        .then(result => {
          this.isTargetLoading = false;
          if (result.data.ResultCode == 100) {
            let groupTypeList = result.data.ResponseData
            for (const element of groupTypeList) {
              this.targetGroupNoList.push({
                value: element.groupno,
                text: element.groupno + ' - ' + element.groupname
              })
            }
          } else {
            this.targetGroupNoList = [];
            this.targetGroupListError = 'List is empty!!';
          }
        }, error => {
          this.isTargetLoading = false;
          console.error(error)
        })
    },
    resetForm() {
      this.listHubZoneData = [];
      this.listHubData = [];
      this.targetcityid = '';
      this.targetcityname = '';
      this.sourcecityid = '';
      this.sourcecityname = '';
      this.sourceGroupNo = '';
      this.sourceGroupName = '';
      this.targetGroupNo = '';
      this.targetGroupName = '';
      this.parentHub = '';
      this.isLoading = false;
      this.isLoadingflt = false;
      this.sourceGroupNoList = [];
      this.targetGroupNoList = [];
      this.targetcityObjData = {
        value: "",
        text: ""
      };
      this.sourcecityObjData = {
        value: "",
        text: ""
      };
      this.sourceGroupNoObjData = {
        value: "",
        text: ""
      };
      this.targetGroupNoObjData = {
        value: "",
        text: ""
      };
      this.totalmappedhubs = 0;
      this.totalSelected = 0;
      this.destinationList = [];
      this.oldDestinationList = [];
      this.zoneLoading = '';
      this.hubLoading = '';
      this.isSourceLoading = false;
      this.isTargetLoading = false;
      this.checkAllHub = false;
      this.destinationLoading = false;
      this.addmodalShow = false;
      this.hubid = 0;
      this.hubzoneid = 0;
      this.oldDataSaved = false;
      this.showList = false;
      this.checkedHub = [];
      this.HubArr = [];
      this.destData = [];
      this.modelArr = [];
      this.allHubData = [];
      this.sourceGroupListError = '';
      this.targetGroupListError = '';
      this.$validator.reset();
    },
    selectedHub() {
      if (this.oldDataSaved == false) {
        this.oldDestinationList = this.destinationList;
        this.oldDataSaved = true;
      }
      let arr = [];
      for (const element of this.oldDestinationList) {
        for (let j = 0; j < element.length; j++) {
          if (Number(element[j].hubId) == Number(this.hubid)) {
            arr.push(element[j]);
            break;
          }
        }
      }
      this.destinationList = []
      this.destinationList.push(arr);
    },
    selectedZone() {
      this.oldDestinationList = this.destinationList;
      this.getDestinations();
    },
    resetZoneHub() {
      this.hubid = 0;
      this.hubzoneid = 0;
      this.oldDataSaved = true;
      this.getDestinations();
    },
    getDestinations() {
      this.destinationList = [];
      this.destinationLoading = true;
      this.listHubData = [];
      this.totalmappedhubs = 0;
      this.hubid = 0;
      this.destData = [];
      this.HubArr = [];
      this.checkAllHub = false;
      this.hubLoading = 'Loading Hub...';
      axios({
        method: 'GET',
        'url': apiUrl.api_url_hubops + 'fetchGroupDestinations?groupno=' + this.sourceGroupNo + ((this.hubzoneid !== 0) ? '&hubzoneid=' + this.hubzoneid : ''),
        headers: {
          'Authorization': "authkey xB84JJ89Hd25"
        }
      })
        .then(result => {
          if (result.data.ResultCode == 100) {
            let j = 0, list = [], dlist = [], totalhubs = 0;
            let hData = result.data.ResponseData;
            if (hData.length !== 0) {
              for (const element of hData) {
                this.listHubData.push({
                  value: element.HubID,
                  text: element.HubName + '(' + element.HubID + ')'
                });
                if (j < 4) {
                  list.push({
                    hubId: element.HubID,
                    hubName: element.HubName
                  });
                } else {
                  dlist.push(list);
                  list = []
                  list.push({
                    hubId: element.HubID,
                    hubName: element.HubName
                  });
                  j = 0;
                }
                j++;

                (this.HubArr.indexOf(element.HubID) === -1) ? this.HubArr.push(element.HubID) : '';
                if (typeof this.checkedHub[element.HubID] == 'undefined')
                  this.checkedHub[element.HubID] = true;

                if (this.checkedHub[element.HubID] == true)
                  totalhubs++;

                this.destData.push({
                  hubId: element.HubID,
                  hubName: element.HubName
                });

                const allH = this.allHubData.some(el => el.hubId === element.HubID);
                if (!allH) {
                  this.allHubData.push({
                    hubId: element.HubID,
                    hubName: element.HubName,
                    hubCode: element.HubCode
                  });
                }
              }
              this.modelArr = (this.modelArr.length > 0) ? this.modelArr : this.HubArr;
              dlist.push(list);
              this.destinationList = [];
              this.destinationList = dlist;
              this.totalmappedhubs = hData.length;
              this.oldDataSaved = false;
              (totalhubs == this.destData.length) ? this.checkAllHub = true : this.checkAllHub = false;
            }
            this.showList = true;
          } else {
            this.$alertify.error(result.data.ReturnMessage, "", "error");
          }
          this.destinationLoading = false;
          this.hubLoading = '';
        }, error => {
          console.error(error);
          this.destinationLoading = false;
          this.hubLoading = '';
        })
    },
    closeStatusModal() {
      this.addmodalShow = false
    },
    migrateDestinations() {
      let hubList = [];
      for (const element of this.allHubData) {
        if (this.checkedHub[element.hubId]) {
          hubList.push({
            HubID: element.hubId,
            HubName: element.hubName,
            HubCode: element.hubCode
          });
        }
      }
      if (hubList.length == 0) {
        this.$alertify.error('Destination list cannot be empty', "", "error");
        return false;
      }
      this.input = {
        previousgroupno: this.sourceGroupNo,
        newgroupno: this.targetGroupNo,
        destinationhubids: hubList,
        lastmodifiedby: this.useremail
      };
      this.isLoading = true;
      axios({
        method: 'POST',
        'url': apiUrl.api_url_hubops + 'migrateDestination',
        'data': this.input,
        headers: {
          'Authorization': "authkey xB84JJ89Hd25"
        }
      })
        .then(result => {
          this.isLoading = false;
          if (result.data.ResultCode == 100) {
            this.$alert(result.data.ReturnMessage, "", "success");
            user_tracker.checkUserIP(this.userData[0], "migrateDestination", this.$route.path , this.input);
            this.resetForm();
          } else {
            this.$alertify.error(result.data.ReturnMessage, "", "error");
          }
        }, error => {
          this.isLoading = false;
          console.error(error);
        })
    },
    onSubmit: function () {
      this.$validator.validateAll().then(async (result) => {
        if (!result) {
          return false;
        }
        else {
          this.addmodalShow = true
        }
      }).catch(() => { });
    },
    checkHub() {
      if (this.checkAllHub) {
        for (const element of this.destData) {
          this.checkedHub[element.hubId] = true;
          this.modelArr.indexOf(element.hubId) === -1 ? this.modelArr.push(parseInt(element.hubId)) : '';
        }
      } else {
        let arr = [];
        for (const element of this.destData) {
          this.checkedHub[element.hubId] = false;
          arr.push(element.hubId);
        }
        this.modelArr = this.modelArr.filter(val => !arr.includes(val));
      }
      if (this.oldDataSaved == true) {
        for (const element of this.oldDestinationList) {
          for (const elmnt of element) {
            this.checkedHub[elmnt.hubId] = this.checkAllHub;
          }
        }
      }
    },
    updateCheckDest(event) {
      this.checkedHub[event.target.id] = event.target.checked;

      if (event.target.checked == false) {
        this.modelArr = this.modelArr.filter(el => el != event.target.id)
      } else {
        this.modelArr.indexOf(event.target.id) === -1 ? this.modelArr.push(parseInt(event.target.id)) : '';
      }

      this.checkAllHub = (this.destData.length === this.modelArr.length) ? true : false;

      if (this.oldDataSaved == true) {
        for (const element of this.oldDestinationList) {
          for (const elemnt of element) {
            if (Number(elemnt.hubId) == Number(event.target.id)) {
              this.checkedHub[elemnt.hubId] = event.target.checked;
              break;
            }
          }
        }
      }
    },
    getHubZoneData() {
      this.listHubZoneData = [];
      this.zoneLoading = 'Loading Zone...';
      axios({
        method: 'POST',
        'url': apiUrl.api_url_hubops + 'hubzone/list',
        'data': {},
        headers: {
          'authorization': 'authkey xB84JJ89Hd25',
        }
      })
        .then(result => {
          if (result.data.ResultCode == 100) {
            let listHubZoneData = result.data.ResponseData;
            for (const element of listHubZoneData) {
              this.listHubZoneData.push({
                value: element.hubzoneid,
                text: element.hubzonename
              })
            }
          }
          this.zoneLoading = '';
        }, error => {
          this.zoneLoading = '';
          console.error(error);
        })
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/components/groupnew/MigrateDestinations/MigrateDestinations.js